<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/utils/shadcn/lib/utils';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    class?: HTMLAttributes['class']
    variant?: 'legend' | 'label'
}>();
</script>

<template>
    <legend
        data-slot="field-legend"
        :data-variant="variant"
        :class="cn(
            'mb-4 font-semibold leading-none text-foreground',
            'data-[variant=legend]:text-lg',
            'data-[variant=label]:text-sm',
            props.class,
        )"
    >
        <slot></slot>
    </legend>
</template>
